var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96 96",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface228057229"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.000001%,40.000001%,40.000001%)",
      fillOpacity: 1
    },
    d: "M 48 4 C 34.703125 4 24 14.703125 24 28 L 24 32 C 21.910156 32 19.78125 32.765625 18.273438 34.273438 C 16.765625 35.78125 16 37.910156 16 40 L 16 80 C 16 82.089844 16.765625 84.21875 18.273438 85.726562 C 19.78125 87.234375 21.910156 88 24 88 L 72 88 C 74.089844 88 76.21875 87.234375 77.726562 85.726562 C 79.234375 84.21875 80 82.089844 80 80 L 80 40 C 80 37.910156 79.234375 35.78125 77.726562 34.273438 C 76.21875 32.765625 74.089844 32 72 32 L 72 28 C 72 14.703125 61.296875 4 48 4 Z M 48 12 C 57.105469 12 64 18.894531 64 28 L 64 32 L 32 32 L 32 28 C 32 18.894531 38.894531 12 48 12 Z M 48 52 C 52.398438 52 56 55.601562 56 60 C 56 64.398438 52.398438 68 48 68 C 43.601562 68 40 64.398438 40 60 C 40 55.601562 43.601562 52 48 52 Z M 48 52 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.8c4d5ca658f1d297a847b391ca7b9e85.svg";
export { ForwardRef as ReactComponent };